import UsersListPage from '../users/UsersListPage'

export const CitizensPage = () => {
    return (
        <UsersListPage />
    )
}
